import BugCatch, { EventPayload } from 'bugcatch-sdk';

const dsn = process.env.REACT_APP_BUGCATCH_DSN;

const isBugCatchEnabled = Boolean(dsn);
if (isBugCatchEnabled) {
    BugCatch.init({
        dsn: dsn as string,
        release: process.env.REACT_APP_VERSION,
        environment: process.env.NODE_ENV,
        debug: process.env.NODE_ENV === 'development',
        ignoreErrors: [/ResizeObserver loop limit exceeded/, /Network Error/],
        beforeSend(event: EventPayload) {
            event.platform = 'web';
            return event;
        },
    });
}

export const bugCatchEnabled = isBugCatchEnabled;

export default BugCatch;